import {IconButton, Stack, styled} from '@mui/material';

const HeaderContainer = styled('header')`
	background-color: ${({theme}) => theme.palette.primary.main};
	color: ${({theme}) => theme.palette.primary.contrastText};
	flex-direction: column;
	display: flex;
`;

const StyledIconButton = styled(IconButton)`
	padding: 12px;
`;

const HeaderNavbar = styled(Stack)`
	justify-content: space-between;
	padding-inline: 24px;
	align-items: center;
	flex-direction: row;
	min-height: 48px;
	margin: 24px 0;

	${({theme}) => theme.breakpoints.down('md')} {
		padding-inline: 8px;
		margin: 4px 0;
	}
`;

export {HeaderContainer, HeaderNavbar, StyledIconButton};
